import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Container,
    Skeleton,

    Breadcrumbs
} from "@mui/material";
import { Link } from "react-router-dom";
import { getUser } from "../../Utils/authHelper";
import ComboCard from "../../Components/ComboCard/ComboCard";

const rubikfont = { fontFamily: "Rubik, sans-serif" };
const API_URL = "https://api.glamcompany.in/api/v1/";

const ComboList = () => {
    const [combos, setCombos] = useState([]);
    const [loading, setLoading] = useState(true);
    const user = getUser();
    const isBusiness = user?.customerType === 'business';

    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchCombos = async () => {
            try {
                const res = await fetch(`${API_URL}combo-offer/all`);
                const data = await res.json();
                if (data.success) setCombos(data.data || []);
            } catch (e) {
                console.error("Failed to fetch combo offers:", e);
            } finally {
                setLoading(false);
            }
        };
        fetchCombos();
    }, []);

    return (
        <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: "#fafafa", minHeight: "80vh" }}>
            <Container maxWidth="xl">
                {/* Breadcrumbs */}
                <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 4, "& .MuiBreadcrumbs-separator": { color: "#C8A054" } }}>
                    <Link to="/" style={{ textDecoration: "none", color: "#666", ...rubikfont, fontSize: "14px", fontWeight: 500 }}>
                        Home
                    </Link>
                    <Typography color="#111" sx={{ ...rubikfont, fontSize: "14px", fontWeight: 600 }}>
                        Combo Packs
                    </Typography>
                </Breadcrumbs>

                {/* Header */}
                <Box sx={{ mb: 3, pb: 2, borderBottom: "1px solid #e0e0e0" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Box sx={{ width: "4px", height: "32px", bgcolor: "#C8A054", borderRadius: "4px" }} />
                        <Box>
                            <Typography sx={{ fontSize: "11px", fontWeight: 600, letterSpacing: "3px", color: "#C8A054", textTransform: "uppercase", mb: 0.5, ...rubikfont }}>
                                Save More Together
                            </Typography>
                            <Typography sx={{ fontSize: { xs: "24px", sm: "30px" }, fontWeight: 800, color: "#111", fontFamily: "'Playfair Display', serif", lineHeight: 1 }}>
                                Combo Packs
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Grid */}
                {loading ? (
                    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 2 }}>
                        {Array.from({ length: 8 }).map((_, i) => (
                            <Box key={i}>
                                <Skeleton variant="rectangular" sx={{ aspectRatio: "1/1", height: "auto", borderRadius: "12px", mb: 1 }} />
                                <Skeleton width="80%" height={24} sx={{ mb: 1 }} />
                                <Skeleton width="40%" height={24} />
                            </Box>
                        ))}
                    </Box>
                ) : combos.length > 0 ? (
                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(auto-fill, minmax(190px, 1fr))" }, gap: { xs: 1.5, sm: 2 } }}>
                        {combos.map((combo) => (
                            <ComboCard key={combo._id} combo={combo} isBusiness={isBusiness} />
                        ))}
                    </Box>
                ) : (
                    <Box sx={{ textAlign: "center", py: 10 }}>
                        <Typography sx={{ fontSize: "24px", fontWeight: 600, color: "#111", mb: 2, ...rubikfont }}>
                            No Combo Packs Available
                        </Typography>
                        <Typography sx={{ fontSize: "16px", color: "#666", ...rubikfont }}>
                            Check back later for new exciting offers!
                        </Typography>
                    </Box>
                )}
            </Container>
        </Box>
    );
};

export default ComboList;
